<template>
    <div class="finTeam">
        <vs-card v-for="(team, index) of teams" :key="index">
            <div class="flex items-center">
                <vs-checkbox @input="send(team)" v-model="team.finance_is_internal"/>
                <div>{{ team.name || team.id }}</div>
            </div>
        </vs-card>
    </div>
</template>

<script>
import ErrorHandler from '@/utils/errorHandler'
import send from '@/utils/fetch'

export default {
    data () {
        return {
            teamList: []
        }
    },

    computed: {
        teams () {
            return this.teamList
        }
    },

    methods: {
        async get () {
            try {
                this.teamList = await send(this.$url.financeStatistic['get-team-types'], 'GET').then(response => response.data.result)
            } catch (e) {
                new ErrorHandler().send
            }
        },

        async send (data) {
            try {
                await send(this.$url.financeStatistic['update-team-type'], 'PUT', {
                    data: {
                        id: data.id,
                        finance_is_internal: data.finance_is_internal ? 1 : 0
                    }
                })
            } catch (e) {
                new ErrorHandler(e).send
            }
        }
    },

    async mounted () {
        try {
            await this.get()
            this.$store.commit('UPDATE_LOADER_STATE', false)
        } catch (e) {
            this.$store.commit('UPDATE_LOADER_STATE_SET_ERROR', true)
            new ErrorHandler(e).send
        }
    }
}
</script>

<style lang="scss">
.finTeam {
    .vs-card--content {
        padding: 5px !important;
        margin-bottom: 10px !important;
    }

    .con-vs-card {
        margin-bottom: 10px !important;
    }
}
</style>
